<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#333">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_student.new ? "Novo" : get_student.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Gerencie os detalhes abaixo
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="get_student._id">
              <v-btn
                color="red"
                @click="excluir_student_dialog(get_student)"
                outlined
                small
                >Excluir</v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </transition>
      </div>
    </v-flex>
    <div class="windows-style-content expande-horizontal wrap">
      <v-flex xs12>
        <v-form ref="form">
          <v-flex class="px-2" xs12>
            <v-text-field
              v-model="get_student.nome"
              dense
              depressed
              filled
              label="Nome"
              placeholder="ex: Roberto"
              clearable
              :color="$theme.primary"
              :rules="[v => !!v || 'Preencha este campo']"
            ></v-text-field>
          </v-flex>
          <v-flex class="px-2" xs12>
            <v-text-field
              v-model="get_student.idade"
              dense
              depressed
              filled
              label="Idade"
              placeholder="ex: 15"
              type="number"
              clearable
              :color="$theme.primary"
              :rules="[v => !!v || 'Preencha este campo']"
            ></v-text-field>
          </v-flex>
          <v-flex class="px-2" xs12>
            <v-select
              v-model="get_student.sexo"
              dense
              depressed
              filled
              :items="['Masculino', 'Feminino']"
              label="Sexo"
              placeholder="ex: Masculino"
              clearable
              :color="$theme.primary"
              :rules="[v => !!v || 'Preencha este campo']"
            ></v-select>
          </v-flex>
          <div class="expande-horizontal">
            <v-flex class="px-2" xs12>
              <v-switch
                v-model="get_student.has_atipicity"
                label="Esse aluno possui alguma atipicidade?"
              ></v-switch>
            </v-flex>
          </div>
          <div
            v-if="get_student.has_atipicity || get_student.obs"
            class="expande-horizontal"
          >
            <v-flex class="px-2" xs12>
              <v-textarea
                v-model="get_student.obs"
                dense
                depressed
                filled
                label="Observações"
                placeholder="obs: deficiências motoras, cega..."
                clearable
                :color="$theme.primary"
                :rules="[v => !!v || 'Preencha este campo']"
              ></v-textarea>
            </v-flex>
          </div>
        </v-form>
      </v-flex>
    </div>

    <div class="windows-style-bottom py-2 expande-horizontal">
      <v-btn
        :color="$theme.primary"
        @click="valida_form"
        depressed
        rounded
        block
      >
        <span class="fonte"> Salvar </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_student", "getLoggedUser"])
  },
  methods: {
    ...mapActions([
      "criar_student",
      "atualizar_student",
      "fecha_modal_view_student",
      "createConfirmAction"
    ]),
    excluir_student_dialog() {
      this.createConfirmAction({
        message: "Deseja realmente excluir?",
        color: "red",
        action: "excluir_student",
        action_value: { _id: this.get_student._id }
      });
    },
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_student._id ? this.atualizar_student() : this.criar_student();
      }
    },
    backToList() {
      this.$store.commit("set_student", {});
      this.$forceUpdate();
    }
  }
};
</script>
